import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSidebarActionsContext } from "../../Context/SidebarManagementContext";
import { useAuthActionsContext } from "./../../Context/AuthContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import {
  useAMGSelectedActionsContext,
  useEqDetailsTabContext,
} from "../../Context/GlobalContext";

import access_controlActions from "../../Actions/Access_ControlActions";
import ChangePassword from "../Masterpage/ChangePassword";
import commonUtils from "../../helpers/commonUtils";
import { useSelectedConfigContext } from "../../Context/GlobalContext";

import PrivacyDisclaimer from "../Access-Control/PrivacyPolicy";

import { FaUserCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";

import { useTourGuidStartActionsContext } from "../../Context/TourGuidContext";
import AdminNavigationBar from "./AdminNavigationBar";
import RegularNavigationBar from "./RegularNavigationBar";

const Navigationsbar = (props) => {
  const location = useLocation();
  const [windowSize, setWindowSize] = useState(null);

  /**Contexts  */
  const UpdateTourStatus = useTourGuidStartActionsContext();
  const { setShowSidebar, handleContentChange } = useSidebarActionsContext();
  const UpdateSelectedAnlageG = useAMGSelectedActionsContext();
  const { localization } = useLanguageContext();
  const UpdateLogged = useAuthActionsContext();

  const tabSelected = useEqDetailsTabContext();
  const selectedConfig = useSelectedConfigContext();

  const logoutEvent = () => {
    handleContentChange(false);
    access_controlActions.logout();
    // updateSelectedFunc(null);
    UpdateSelectedAnlageG(null);
    UpdateLogged(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowSize !== null && windowSize !== undefined) {
      if (windowSize <= 1170) {
        if (location.pathname !== "/dashboard") {
          setShowSidebar(false);
        }
      } else {
        setShowSidebar(true);
      }
    }
  }, [windowSize]);

  const RenderUserProfileButton = () => {
    return (
      <FaUserCircle
        className="ml-1 cursorPoint svgIcon dropdown-toggle"
        data-toggle="dropdown"
        id="profileIcon"
        size={40}
      ></FaUserCircle>
    );
  };

  const handleTourGuide = () => {
    const currentRoute = location.pathname;
    setShowSidebar(true);
    if (currentRoute.startsWith("/equipmentGrpEqiupment/")) {
      const dynamicPart = currentRoute.split("/")[2];
      if (dynamicPart) {
        UpdateTourStatus({
          tourTitle: "EquipmentDetailsViewTour",
          tourStatus: true,
          anyStep: 0,
          lastIndexKey:
            tabSelected["tabDetails"][tabSelected["tabDetails"].length - 1].id,
          firstIndexKey: tabSelected["tabDetails"][0].id,
        });
      } else {
        UpdateTourStatus({
          tourTitle: "WelcomeTour",
          tourStatus: true,
          anyStep: 0,
        });
      }
    } else if (location.pathname.includes("/setting/")) {
      UpdateTourStatus({
        tourTitle: "SettingsViewTour",
        tourStatus: true,
        anyStep: 0,
      });
    } else if (location.pathname.includes("/dashboard")) {
      UpdateTourStatus({
        tourTitle: "WelcomeTour",
        tourStatus: true,
        anyStep: 0,
      });
    }
  };

  const getLoggedInUserInfo = (
    <div className="loggedInInfo text-right d-flex justify-content-end">
      <span className="pr-2 pt-3">
        <span className="user useName">
          {sessionStorage.getItem("username")}
        </span>
        <br />
        <span className="org">{sessionStorage.getItem("organization")}</span>
      </span>

      <div id="userPorfileIcon" className="dropdown userPorfileIcon pt-4">
        <RenderUserProfileButton />

        <ul className="dropdown-menu dropdown-menu-right wordRap remove">
          <li
            type="button"
            className="nav-item nav-link mb-1"
            data-toggle="modal"
            data-target="#changePassword"
          >
            {localization.modifypwd}
          </li>
          {!commonUtils.isUserWebsiteAdmin() && (
            <a
              target="_blank"
              //  href={`https://alm.txsas.com/#/UG/19FC9873-E9D5-C4F4-405B-08DB0B2C6E8E`}
              href={
                selectedConfig === ""
                  ? "https://alm.txsas.com/#/UG/19FC9873-E9D5-C4F4-405B-08DB0B2C6E8E"
                  : `https://alm.txsas.com/#/UG/19FC9873-E9D5-C4F4-405B-08DB0B2C6E8E/${selectedConfig}`
              }
            >
              <li>{localization.help}</li>
            </a>
          )}
          {!commonUtils.isUserWebsiteAdmin() &&
            !commonUtils.isSupportUser() && (
              <a
                target="_blank"
                href=" https://support.graubner-gmbh.de/portal/de/kb/graubner-helpcenter"
              >
                <li>{localization.support}</li>
                {/* <RenderSupportButton /> */}
              </a>
            )}
          {!commonUtils.isUserWebsiteAdmin() && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.initLightbox();
              }}
            >
              {" "}
              <li>{localization.privacydisclaimer}</li>
            </a>
          )}
          {!commonUtils.isUserWebsiteAdmin() &&
            !location.pathname.includes("/inspection/") && (
              <li
                type="button"
                className="nav-item nav-link mb-1"
                onClick={handleTourGuide}
              >
                {localization.startTour}
              </li>
            )}

          <NavLink
            className={({ isActive }) => ""}
            to="/dashboard"
            onClick={logoutEvent}
          >
            <li className="nav-item nav-link ">
              <span className="glyphicon glyphicon-log-out"></span>

              {localization.Logout}
            </li>
          </NavLink>
        </ul>
      </div>
    </div>
  );

  const isAdminUser =
    commonUtils.isUserWebsiteAdmin() || commonUtils.isSupportUser();
  return (
    <header>
      {isAdminUser ? (
        <AdminNavigationBar getLoggedInUserInfo={getLoggedInUserInfo} />
      ) : (
        <RegularNavigationBar
          handleContentChange={handleContentChange}
          userProfile={getLoggedInUserInfo}
        />
      )}
      <PrivacyDisclaimer />
      <ChangePassword />
    </header>
  );
};
export default Navigationsbar;
